import React from 'react';
import { useState, useEffect } from 'react' 
import { Link } from 'react-router-dom';
import { db } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

const Angular = ({portfolioData})=> {  
    return (
        <>
            {/* <div className="page-hd clearfix">
                <div className="left-float" style={{marginTop: "0px", marginRight: "20px"}}>
                    <img src="/images/skin1/angular-logo.png" /> 
                </div>
                <div className="left-float" style={{marginTop: "10px"}}>
                    <p><strong>Experience: 4.5 Years</strong></p>
                    <p><strong></strong></p>
                </div>
            </div> */}
            <h1>Angular <h3>- 4 Years</h3></h1> 
            <ul>
                <li>- Good experience creating modular and scalable Angular components.</li>
                <li>- Good experience creating Services to integrate with backend APIs.</li>
                <li>- Worked with Observables programming to subscribe the data changes and broadcast to the subscribers.</li>
                <li>- Created custom components like AutoComplete, Pagination and Sorting.</li> 
            </ul>
            {/* <h3>Angular Projects</h3><hr />
            <div className="flex-row-container"> 
                {
                    portfolioData.length > 0 ?
                        portfolioData.map((item, index) => {
                            const url = item.data.project_files[0];
                            return ( 
                                    <div className="flex-item card link" key={index}>
                                        <div>
                                            <div className="card-tn" style={{backgroundImage:`url(${url})`, backgroundPosition:'top left'  }}>
                                            </div>
                                            <div className="card-content">
                                                <p className="txt-18 thickest">
                                                {item.data.project_title}
                                                </p>
                                            </div>
                                        </div>
                                    </div> 
                            )
                        }) : <> <div className="loader"></div></>
                } 
            </div>  */}
        </>
    )
}
export default Angular;